// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Event listener on scroll
     */

    window.addEventListener('scroll', () => {
        shrinkNav();
    });

    /**
     * Event listener on resize
     */

    window.addEventListener('resize', () => {
        shrinkNav();
    });

    /**
     * Toggle shrink class
     */

    const shrinkNav = () => {
        if (window.scrollY > 50) {
            document.querySelector('body').classList.add('shrink-nav');
        } else {
            document.querySelector('body').classList.remove('shrink-nav');
        }
    }

});
